<template>
  <div class="header">
    <div class="header-left">📍 河南 · 济源</div>
    <h1>{{ title }}</h1>
    <div class="header-right">
      <div class="time">
        🟢 {{ onlineSites }}站在线 · {{ currentTime }}
        <span class="weather-accent">☀️ 晴 26°C</span>
      </div>
      <b-navbar-nav class="pv-header-navbar align-items-center">
        <!-- 子系统 / 平台切换，与 Index 顶部「更多」一致 -->
        <b-nav-item-dropdown
          id="pv-header-system-dropdown"
          class="pv-header-dropdown pv-header-system-dropdown navbar-transparent"
          menu-class="pv-dropdown-menu-theme pv-dropdown-menu-theme--system"
          right
          no-caret
          toggle-class="pv-more-toggle"
          v-if="showSystemMenu"
          v-show="!isOverviewSettingRoute"
        >
          <template #button-content>
            <img
              class="pv-header-more-img"
              :src="require('@/assets/images/menu.png')"
              alt="其它系统"
            />
          </template>
          <div v-for="item in linkage" :key="'lk-' + item.clientId">
            <b-nav-item
              v-if="item.autoApprove === 'true'"
              :href="item.website"
              :target="item.autoApprove === 'true' ? '_blank' : ''"
              :class="item.autoApprove === 'true' ? 'titleLine' : ''"
            >
              <span v-if="item.autoApprove === 'true'">{{ item.appName }}</span>
            </b-nav-item>
          </div>
          <div v-for="(item, index) in systemSwitchingData" :key="'sw-' + index">
            <b-nav-item
              v-if="
                item.navUrl === 'device-manager' ||
                item.navUrl === 'ptms-cabinet' ||
                item.navUrl === 'electricity' ||
                item.navUrl === 'group-control'
              "
              :key="item.id"
              :href="
                item.navUrl === 'device-manager'
                  ? IOTPlatformUrl
                  : item.navUrl === 'ptms-cabinet'
                  ? ptmsCabinetUrl
                  : item.navUrl === 'electricity'
                  ? electricityUrl
                  : groupControlUrl
              "
              :target="item.parameters === '_blank' ? '_blank' : '_self'"
              :class="[item.parameters === '_blank' ? 'titleLine' : '']"
            >
              <router-link
                v-if="item.parameters === 'native'"
                class="pv-header-sys-router-link"
                :to="item.navUrl"
                tag="a"
                target="_blank"
                @touchstart.native="newPage(item.navUrl, true)"
                @click.native="newPage(item.navUrl, true)"
              >
                <img v-if="item.imgOut" :src="item.imgOut" alt="" />
                {{ item.cnName }}
              </router-link>
              <router-link
                v-else
                class="pv-header-sys-router-link"
                :to="item.navUrl"
                tag="div"
              >
                <span>{{ item.cnName }}</span>
              </router-link>
            </b-nav-item>
          </div>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          id="pv-header-account-dropdown"
          class="pv-header-dropdown navbar-transparent"
          menu-class="pv-dropdown-menu-theme"
          right
          no-caret
          toggle-class="pv-account-toggle"
        >
          <template #button-content>
            <b-avatar
              :src="
                account.avatar
                  ? $ftpUrl + account.avatar
                  : require('@/assets/images/default/user_avatar_default.png')
              "
              class="pv-header-avatar mr-1 d-inline-block bg-transparent align-top"
              size="sm"
            />
            <span class="pv-header-display-name">{{ accountName }}</span>
            <span class="pv-header-caret">▾</span>
          </template>
          <b-dropdown-item> [ {{ account.code || "——" }} ]</b-dropdown-item>
          <b-dropdown-item href="#" @click.prevent="openProfile" @touchstart.prevent="openProfile">
            个人资料
          </b-dropdown-item>
          <b-dropdown-item href="#" @click.prevent="onLogout" @touchstart.prevent="onLogout">
            退出登录
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getAccountInfo } from "@/network/account";
import { logout, redirectLogin } from "@/network/sso";
import { getSystematicByParent } from "@/network/systematic";
import { getResourceList } from "@/network/resource";

export default {
  name: "PvHeader",
  props: {
    title: {
      type: String,
      default: "河南联通（济源）分公司综合能源管控平台",
    },
    onlineSites: {
      type: Number,
      default: 128,
    },
  },
  data() {
    return {
      currentTime: "",
      timer: null,
      account: {},
      accountDetail: {},
      accountName: "管理员",
      iamUrl:
        (typeof window !== "undefined" &&
          window.g &&
          window.g.iamUrl &&
          `${window.g.iamUrl}?index=personal/index`) ||
        "?index=personal/index",
      linkage: [],
      systemSwitching: false,
      systemSwitchingData: [],
      IOTPlatformUrl: "#/device-manager/device-space",
      groupControlUrl: "#/group-control",
      ptmsCabinetUrl: "#/ptms-cabinet",
      electricityUrl: "#/electricity",
    };
  },
  computed: {
    showSystemMenu() {
      return (
        this.systemSwitching ||
        (Array.isArray(this.linkage) && this.linkage.length > 0)
      );
    },
    isOverviewSettingRoute() {
      const path = this.$route && this.$route.path ? this.$route.path : "";
      return path.indexOf("/overview-setting") !== -1;
    },
  },
  mounted() {
    this.tick();
    this.timer = setInterval(this.tick, 1000);
    this.loadAccountInfo();
    this.getLinkage();
    this.loadSwitchPlatforms();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    tick() {
      this.currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
    },
    getLinkage() {
      getSystematicByParent().then((res) => {
        if (res && res.data != null) {
          this.linkage = Array.isArray(res.data) ? res.data : [];
        }
      }).catch(() => {
        this.linkage = [];
      });
    },
    loadSwitchPlatforms() {
      getResourceList()
        .then((res) => {
          if (res.code !== 0 || !res.data || !res.data.resources) {
            return;
          }
          const menus = res.data.resources.filter((item) => item.superId === "0");
          const data = [];
          let systemSwitchingTrue = false;
          for (let i = 0; i < menus.length; i++) {
            const u = menus[i].navUrl;
            if (
              u === "assetUrl" ||
              u === "device-manager" ||
              u === "electricity" ||
              u === "group-control" ||
              u === "ptms-cabinet"
            ) {
              data.push(menus[i]);
              systemSwitchingTrue = true;
            }
          }
          this.systemSwitching = systemSwitchingTrue;
          this.systemSwitchingData = data;
        })
        .catch(() => {
          this.systemSwitching = false;
          this.systemSwitchingData = [];
        });
    },
    /** 与其它页一致：native 路由内跳转，否则新开窗口（个人资料 IAM） */
    newPage(pageUrl, useRouterPush) {
      if (useRouterPush) {
        this.$router.push(pageUrl).catch(() => {});
      } else {
        window.open(pageUrl, "_blank");
      }
    },
    loadAccountInfo() {
      getAccountInfo()
        .then((res) => {
          if (!res || !res.data) return;
          this.account = res.data.account || {};
          this.accountDetail = res.data.accountDetail || {};
          if (this.account.nickname) {
            this.accountName = this.account.nickname;
          } else if (this.accountDetail.name) {
            this.accountName = this.accountDetail.name;
          } else if (this.account.code) {
            this.accountName = this.account.code;
          } else {
            this.accountName = "管理员";
          }
        })
        .catch(() => {
          if (!this.accountName) this.accountName = "管理员";
        });
    },
    openProfile() {
      window.open(this.iamUrl, "_blank");
    },
    onLogout() {
      logout().then((res) => {
        if (typeof console !== "undefined" && console.log) console.log(res);
      });
      redirectLogin();
    },
  },
};
</script>
